import { ServiceClient } from "./lib";
import { service } from "./cloud";

export const client = new ServiceClient(service);
